import React from 'react';
import { Table, SortableTh, RowActions, ACTIONS_COL_WIDTH } from '@/components/ui';
import { DataSourceItem } from '../../../types/DataSource';
import { useClientSort } from '../../../utils/useClientSort';

export interface DataSourceColumn {
  key: keyof Pick<DataSourceItem, 'code' | 'name' | 'type' | 'property'>;
  label: string;
}

interface DataSourcesTableProps {
  items: DataSourceItem[];
  columns: DataSourceColumn[];
  onEdit: (item: DataSourceItem) => void;
  onDelete: (item: DataSourceItem) => void;
  canEdit: boolean;
  canDelete: boolean;
}

const SORT_VALUES: Record<string, (i: DataSourceItem) => string | number | null | undefined> = {
  code: (i) => i.code,
  name: (i) => i.name,
  type: (i) => i.type,
  property: (i) => i.property,
};

const DataSourcesTable: React.FC<DataSourcesTableProps> = ({
  items,
  columns,
  onEdit,
  onDelete,
  canEdit,
  canDelete
}) => {
  const { sorted, sortBy, sortDir, onSort } = useClientSort(items, SORT_VALUES);
  return (
    <Table responsive striped hover>
        <thead>
          <tr>
            {columns.map(column => (
              <SortableTh
                key={column.key}
                label={column.label}
                sortKey={column.key}
                activeKey={sortBy}
                direction={sortDir}
                onSort={onSort}
              />
            ))}
            {(canEdit || canDelete) && (
              <th style={{ width: ACTIONS_COL_WIDTH }} className="tw-text-right">Actions</th>
            )}
          </tr>
        </thead>
        <tbody>
          {sorted.map(item => (
            <tr key={item.id}>
              {columns.map(column => (
                <td key={`${item.id}-${column.key}`}>
                  {item[column.key] || '-'}
                </td>
              ))}
              {(canEdit || canDelete) && (
                <td>
                  <RowActions
                    actions={[
                      { kind: 'edit', onClick: () => onEdit(item), hidden: !canEdit },
                      { kind: 'delete', onClick: () => onDelete(item), hidden: !canDelete },
                    ]}
                  />
                </td>
              )}
            </tr>
          ))}
        </tbody>
    </Table>
  );
};

export default DataSourcesTable;
